// @ts-strict-ignore
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lm-notification',
  standalone: false,
  templateUrl: 'lm-notification.component.html',
  styleUrls: [ './lm-notification.component.scss' ],
  providers: []
})

export class LMNotificationComponent {

  @Input() isVisible: boolean | false;
  @Input() notificationType: NotificationType | 'info';
  @Input() message:  string;
  @Input() actionMessage:  string;
  @Input() userObject:  any;

  @Output() lmNotificationEvent = new EventEmitter<LMNotificationEvent>();

  public onLMNotificationEvent(event: LMNotificationEvent): void {
    this.lmNotificationEvent.emit(event);
  }

  public handleClose(): void {
    this.isVisible = false;
  }

  public handleActionClick(): void {
    this.isVisible = false;
    this.onLMNotificationEvent({notificationType: this.notificationType, userObject: this.userObject})
  }
}
